module.exports = __webpack_public_path__ + "static/img/category_todos.95e61fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/category_todos.jpg
// module id = yCv/
// module chunks = 0